"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Pagination = void 0;
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _constants = require("./constants");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
/** Component that displays pagination info. Displays info text, pagination progress value in MUI `LinearProgress` and button for loading another page. */
const Pagination = ({
  button,
  className,
  infoText,
  progress,
  hideProgress
}) => {
  const {
    label,
    onClick,
    disabled,
    loading,
    visible
  } = button;
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.Root, {
    className: className,
    "data-testid": getTestId(_constants.PAGINATION),
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.InfoText, {
      fontWeight: "bold",
      color: "textPrimary",
      children: infoText
    }), hideProgress ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.LinearProgress, {
      "aria-label": label,
      color: "secondary",
      isButtonVisible: visible,
      value: progress,
      variant: "determinate"
    }) : null, visible ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.PaginationLoadMoreButton, {
      variant: "outlined",
      disabled: disabled,
      loading: loading,
      size: "medium",
      onClick: onClick,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
        children: label
      })
    }) : null]
  });
};
exports.Pagination = Pagination;
//# sourceMappingURL=Pagination.js.map